import { useContext } from 'react';

import type { OpenPixContextProps as ContextProps } from './OpenPixContext.tsx';
import OpenPixContext from './OpenPixContext.tsx';

export type OpenPixContextProps = ContextProps;

const useStoreContext = () => {
  const storeContext = useContext(OpenPixContext);

  return {
    openPixState: storeContext.openPixState,
    setOpenPixState: storeContext.setOpenPixState,
  };
};

export default useStoreContext;
